function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBreakB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 2208 2184",
    xmlSpace: "preserve",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 1104,99 c -547.38783,0 -993,445.61217 -993,993 0,547.3877 445.61217,993 993,993 547.3877,0 993,-445.6123 993,-993 C 2097,544.61217 1651.3877,99 1104,99 Z M 845.43488,1334.0609 H 762.9141 V 844.43766 h 82.52078 z m 181.54562,475.8699 H 944.4598 V 379.57062 h 82.5207 z m 189.7977,-173.2936 h -82.5205 V 552.86425 h 82.5205 z m 195.2993,-121.0306 h -82.5207 V 646.3878 h 82.5207 z m 189.7977,-299.8255 h -82.5206 V 957.21603 h 82.5206 z",
    id: "path230",
    style: {
      strokeWidth: 27.507
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBreakB2B);
export default __webpack_public_path__ + "static/media/logo-break-b2b.2660bc683169af62c6f7a3d2b431faec.svg";
export { ForwardRef as ReactComponent };